import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import user from 'js/lib/user';

const updateUserLanguage = gql`
  mutation UpdateLearnerLocaleProfilesV1Mutation($id: String!, $input: Object!) {
    ProfilesV1(id: $id, input: $input) @rest(path: "profiles.v1/{args.id}", method: "PUT") {
      update(id: $id, input: $input) {
        id
      }
    }
  }
`;

type UpdateUserLanguageVars = {
  id: string;
  input: {
    id: string;
    userId: number;
    locale: string;
    externalId: string;
  };
};

const useSetUserLocaleMutation = () => {
  const [mutate] = useMutation<{}, UpdateUserLanguageVars>(updateUserLanguage);
  const id = '' + user.get().id;

  return async (locale: string) => {
    await mutate({
      variables: {
        id,
        input: {
          id,
          userId: user.get().id,
          externalId: user.get().external_id,
          locale: locale.replace('-', '_'), // make sure that the locale is in the correct format
        },
      },
    });
  };
};

export { useSetUserLocaleMutation };
